import { render, staticRenderFns } from "./CriteriaBanner.vue?vue&type=template&id=71e4b852&scoped=true"
import script from "./CriteriaBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CriteriaBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriteriaBanner.vue?vue&type=style&index=0&id=71e4b852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e4b852",
  null
  
)

export default component.exports